'use strict';

var init = function (_a) {
    var gtmId = _a.gtmId, events = _a.events;
    var dataLayerScript = document.createElement("script");
    dataLayerScript.innerHTML = "\n    window.dataLayer = []\n    ".concat(events ? "window.dataLayer.push(...".concat(JSON.stringify(events), ")") : "", "\n  ");
    var gtmScript = document.createElement("script");
    gtmScript.innerHTML = "\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','".concat(gtmId, "');\n  ");
    var iframe = document.createElement("noscript");
    iframe.innerHTML = "\n    <iframesrc=\"https://www.googletagmanager.com/ns.html?id=".concat(gtmId, "\"\n      height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>\n  ");
    document.head.prepend(dataLayerScript);
    document.head.prepend(gtmScript);
    document.body.prepend(iframe);
};
var track = function (event) {
    if (window.dataLayer) {
        window.dataLayer.push(event);
    }
};

exports.init = init;
exports.track = track;
